import React, { useEffect, useState } from 'react'

const GoogleTagManager = ({ tl_env }) => {
  const [isClient, setIsClient] = useState(false)

  useEffect(() => {
    setIsClient(true)
  }, [])

  // Only render Google Analytics in production
  if (tl_env !== 'production') {
    return null
  }

  return (
    <>
      {/* Google Analytics Script */}
      <script async src="https://www.googletagmanager.com/gtag/js?id=G-2PTY4PG5TB" />
      {isClient && (
        <>
          <script
            dangerouslySetInnerHTML={{
              __html: `
                window.dataLayer = window.dataLayer || [];
                function gtag(){dataLayer.push(arguments);}
                gtag('js', new Date());
                gtag('config', 'G-2PTY4PG5TB');
              `,
            }}
          />
          <script
            dangerouslySetInnerHTML={{
              __html: `
                gtag('config', 'AW-370292220');
              `,
            }}
          />
          <script
            dangerouslySetInnerHTML={{
              __html: `
                gtag('event', 'conversion', {'send_to': 'AW-370292220/20nvCL6Y6coYEPzryLAB'})
              `,
            }}
          />
        </>
      )}
    </>
  )
}

export default GoogleTagManager
